import React, { useState } from "react";
import PropTypes from "prop-types";
import { parse, isValid, format } from "date-fns";
import { enGB } from "date-fns/locale";
import locale from "@/mixins/locale";

const localeArr = "modules.components.Registraion.Birthdate";

const Birthdate = props => {
	const [birthdate, setBirthdate] = useState({
		year: null,
		month: null,
		day: null
	});

	const birthdateObj = () => {
		const obj = {
			day: [],
			month: locale(localeArr + ".month"),
			year: []
		};

		for (let i = 1; i < 32; i++) {
			obj.day.push(i);
		}

		for (let i = 2004; i >= 1922; i--) {
			obj.year.push(i);
		}

		return obj;
	};

	const setDate = (key, value) => {
		const obj = { ...birthdate };
		obj[key] = value;
		setBirthdate(obj);

		const keys = ["year", "month", "day"];
		const isInvalid = keys.find(item => !item);

		let date = null;

		if (!isInvalid) {
			const parsedDate = parse(`${obj.day}/${obj.month}/${obj.year}`, "P", new Date(), { locale: enGB });

			date = isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : null;
		}

		props.setValue("birthdate", date);
	};

	return (
		<div className="flex flex-col w-full">
			<p className="pb-3 text-defaultRegistraionBirthdateLabel font-defaultRegistraionBirthdateLabel">{locale(localeArr + ".label")}</p>
			<div className="birthday-picker text-white flex-grow-1">
				<select
					className="text-defaultRegistrationInput font-defaultRegistrationInput col-span-4 form-control bg-transparent border-bottom-registration text-center outline-none"
					onChange={e => setDate("day", e.target.value)}
					id="dobday">
					<option value="">{locale(localeArr + ".labels.day")}</option>
					{birthdateObj().day.map((item) => {
						return (
							<option key={"day-key-" + item} value={item}>
								{item}
							</option>
						);
					})}
				</select>

				<select
					className={`text-defaultRegistrationInput font-defaultRegistrationInput form-control bg-transparent border-bottom-registration mx-4 text-center outline-none ${
						birthdate.month ? "col-span-5" : "col-span-4"
					}`}
					onChange={e => setDate("month", e.target.value)}
					id="dobmonth">
					<option value="">{locale(localeArr + ".labels.month")}</option>
					{birthdateObj().month.map((item, index) => {
						return (
							<option key={"month-key-" + item} value={index + 1}>
								{item}
							</option>
						);
					})}
				</select>

				<select
					className="text-defaultRegistrationInput font-defaultRegistrationInput col-span-4 form-control bg-transparent border-bottom-registration text-center outline-none"
					onChange={e => setDate("year", e.target.value)}
					id="dobyear">
					<option value="">{locale(localeArr + ".labels.year")}</option>
					{birthdateObj().year.map((item) => {
						return (
							<option key={"year-key-" + item} value={item}>
								{item}
							</option>
						);
					})}
				</select>
			</div>
		</div>
	);
};

Birthdate.propTypes = {
	setValue: PropTypes.func
};

export default Birthdate;
